import { createEffect, createSignal } from 'solid-js';

export const CautionInput = (props: {
  label: string;
  value: string | number | null | undefined;
  placeholder?: string;
  onKeyDown?: (e: { currentTarget: { value: string }; key: string }) => void;
  onChange?: (e: { target: { value: string } }) => void;
  onInput?: (e: { target: { value: string } }) => void;
  disabled?: boolean;
  required?: boolean;
  caution?: boolean;
  cautionClass?: string;
  cautionLabelClass?: string;
  error?: string | string[] | null | boolean;
  ref?: (el: HTMLInputElement) => void;
  resetDirty?: boolean;
}) => {
  const [isDirty, setIsDirty] = createSignal(false);
  const yellowify = () => {
    if (props.cautionClass) return props.caution ?? false;
    return (props.caution ?? false) && isDirty();
  };
  createEffect(() => {
    if (props.resetDirty) {
      setIsDirty(false);
    }
  });
  const hasError = () => {
    return (
      props.error !== false &&
      props.error !== null &&
      props.error !== undefined &&
      (Array.isArray(props.error) ? props.error.length > 0 : props.error !== '')
    );
  };
  return (
    <div class="relative my-1 ">
      <input
        class={`peer w-full px-3 py-2 border rounded-md shadow-xs focus:outline-hidden
          disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500
          placeholder:opacity-0 focus:placeholder:opacity-100 ${
            hasError()
              ? 'border-error-red focus:border-error-red hover:border-error-red bg-error-red'
              : yellowify()
                ? (props.cautionClass ??
                  'border-caution-yellow bg-caution-yellow')
                : 'border-[#80b6cf] focus:border-[#123b50] hover:border-[#123b50]'
          }`}
        value={props.value ?? ''}
        onChange={props.onChange}
        onInput={(e) => {
          const isEmpty = e.target.value === '';
          setIsDirty(!isEmpty);
          props.onInput?.(e);
        }}
        onKeyDown={props.onKeyDown}
        placeholder={props.placeholder ?? ''}
        ref={props.ref}
        disabled={props.disabled}
      />
      <label
        class={`text-shadow-thick absolute bg-transparent left-2 px-1 text-sm font-medium transition-all duration-200 ease-out pointer-events-none -top-2.5 
          peer-placeholder-shown:top-2.5  peer-placeholder-shown:text-gray-500 peer-focus:-top-2.5 peer-focus:text-sm peer-disabled:text-gray-400 ${
            hasError()
              ? 'text-error-red peer-focus:text-error-red peer-placeholder-shown:text-error-red'
              : yellowify()
                ? (props.cautionLabelClass ?? 'text-caution-yellow')
                : 'text-armstrong-primary peer-focus:text-armstrong-primary'
          }`}
      >
        {props.label}
        {props.required && <span class="text-error-red bg-white"> *</span>}
      </label>
      {hasError() && (
        <div class="text-error-red text-xs mt-1 ml-1">{props.error}</div>
      )}
    </div>
  );
};
